// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__26ebU","content__text":"Content_content__text__18utS","content__text__description":"Content_content__text__description__1wCd5"};